module.exports = __webpack_public_path__ + "static/media/sadt-icon.070f95cc.svg";